import { render, staticRenderFns } from "./studentPopup.vue?vue&type=template&id=7964febe&scoped=true"
import script from "./studentPopup.vue?vue&type=script&lang=js"
export * from "./studentPopup.vue?vue&type=script&lang=js"
import style0 from "./studentPopup.vue?vue&type=style&index=0&id=7964febe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7964febe",
  null
  
)

export default component.exports